/** Devices against the plan's cap, with any extra devices and the (uncounted) discovery ranges. */
import type {DeviceUsageInfo} from '@/types/device';

export default function DeviceUsage({usage}:{usage:DeviceUsageInfo}){
  const n=(value:number)=>value.toLocaleString('en-US'),plan=usage.device_limit-usage.extra_devices;
  return <section aria-label="Devices" className="space-y-1 text-sm">
    <p className="font-medium">{n(usage.device_count)} of {n(usage.device_limit)} devices{usage.extra_devices>0&&` (${n(plan)} on the plan + ${n(usage.extra_devices)} extra)`}</p>
    <p className="text-gray-600">IP addresses, domains and URLs each count as a device.{usage.range_count>0&&` ${n(usage.range_count)} discovery range${usage.range_count===1?'':'s'} (not counted).`}</p>
    {usage.over_limit&&<p role="alert" className="rounded bg-amber-50 p-2 text-amber-900">You're over your device limit. Existing devices are still scanned, but you can't add more until you remove some or your limit increases.</p>}
  </section>;
}
